export default "__VITE_ASSET__D6x3OC29__"